import type { TdHTMLAttributes } from 'react';

import { cn } from '../../lib/utils';

interface TableCellProps extends TdHTMLAttributes<HTMLTableCellElement> {
  numeric?: boolean;
}

export function TableCell({ className, numeric = false, ...props }: TableCellProps) {
  return (
    <td className={cn('px-3 py-2', numeric && 'text-right tabular-nums', className)} {...props} />
  );
}
